import { Link, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';

import React from 'react';

import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import ExitToApp from '@mui/icons-material/ExitToApp';
import HomeIcon from '@mui/icons-material/Home';
import SettingsIcon from '@mui/icons-material/Settings';
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import FactoryIcon from '@mui/icons-material/Factory';
import Collapse from '@mui/material/Collapse';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import TableChartIcon from '@mui/icons-material/TableChart';
import Badge from '@mui/material/Badge';

// import APIs
import LoadingByDest from './../../../api/admin/report/weighbridge/LoadingByDest';

// redux seters
import { RootState } from './../../../redux/reducers';
import { FromInt } from './../../../helpers/NumberTools';

function TopNav(props) {
  // redux hooks
  const { auth } = useSelector((state: RootState) => state.adminAuth);
  const token = auth.token;

  const location = useLocation();
  const logOut = props.logOut;
  const [openFilter, setOpenFilter] = React.useState(false);
  const [openTransport, setOpenTransport] = React.useState(false);
  const [openLoadings, setOpenLoadings] = React.useState(false);
  const [loadings, setLoadings] = React.useState([]);
  const openMenu = props.Open;

  const styleList = !openMenu
    ? { alignItems: 'center', display: 'contents' }
    : { alignItems: '', display: '' };

  const selectedMenu = (route) => {
    return location.pathname === route ? `panel-link-row` : null;
  };
  const handleClickFilter = () => {
    setOpenFilter(!openFilter);
  };
  const handleClickTransport = () => {
    setOpenTransport(!openTransport);
  };
  const handleClickLoadings = () => {
    setOpenLoadings(!openLoadings);
  };

  // catch data **************************************************
  const catchData = async () => {
    const result = await LoadingByDest(token);
    if (result.status === 200) {
      setLoadings(result.data);
      return;
    }
  };

  React.useEffect(() => {
    catchData();
  }, []);
  return (
    <>
      {' '}
      <List
        sx={{
          width: '100%',
          maxWidth: 360,
          bgcolor: 'background.paper',
        }}
        component="nav"
        dir="ltr"
        aria-labelledby="nested-list-subheader"
      >
        <Link to="/" className="panel-link">
          <ListItemButton className={selectedMenu('/')}>
            {openMenu ? <ListItemText primary="خانه" /> : ''}
            <ListItemIcon style={styleList}>
              <HomeIcon className="ms-auto" />
            </ListItemIcon>
          </ListItemButton>
        </Link>
        {/* <Link to="/admin/setting" className="panel-link">
          <ListItemButton className={selectedMenu('/admin/setting')}>
            {openMenu ? <ListItemText primary="تنظیمات" /> : ''}
            <ListItemIcon style={styleList}>
              <SettingsIcon className="ms-auto" />
            </ListItemIcon>
          </ListItemButton>
        </Link> */}

        {/* <Link to="/security" className="panel-link">
          <ListItemButton className={selectedMenu('/security')}>
            {openMenu ? <ListItemText primary="حراست" /> : ''}
            <ListItemIcon style={styleList}>
              <VerifiedUserIcon className="ms-auto" />
            </ListItemIcon>
          </ListItemButton>
        </Link> */}

        <ListItemButton onClick={handleClickTransport}>
          {openMenu ? (
            openTransport ? (
              <ExpandLessIcon />
            ) : (
              <ExpandMoreIcon />
            )
          ) : (
            ''
          )}
          {openMenu ? <ListItemText primary=" حمل و نقل " /> : ''}

          <ListItemIcon style={styleList}>
            <LocalShippingIcon className="ms-auto" />
          </ListItemIcon>
        </ListItemButton>
        {openMenu ? (
          <Collapse in={openTransport} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              {/* <Link to="/admin/car" className="panel-link">
                <ListItemButton
                  sx={{ pr: 4 }}
                  className={selectedMenu('/admin/car')}
                >
                  <ListItemText>
                    <div className="sub-menu"> لیست تانکرها و رانندگان </div>
                  </ListItemText>
                </ListItemButton>
              </Link> */}
              <Link to="/transport/discharge/ontheway" className="panel-link">
                <ListItemButton
                  sx={{ pr: 4 }}
                  className={selectedMenu('/transport/discharge/ontheway')}
                >
                  <ListItemText>
                    <div className="sub-menu"> در مسیر تخلیه </div>
                  </ListItemText>
                </ListItemButton>
              </Link>

              <Link to="/transport/discharge/waiting" className="panel-link">
                <ListItemButton
                  sx={{ pr: 4 }}
                  className={selectedMenu('/transport/discharge/waiting')}
                >
                  <ListItemText>
                    <div className="sub-menu"> در پارکینگ جهت تخلیه </div>
                  </ListItemText>
                </ListItemButton>
              </Link>
              <Link to="/transport/loading/ontheway" className="panel-link">
                <ListItemButton
                  sx={{ pr: 4 }}
                  className={selectedMenu('/transport/loading/ontheway')}
                >
                  <ListItemText>
                    <div className="sub-menu"> در مسیر بارگیری </div>
                  </ListItemText>
                </ListItemButton>
              </Link>
              <Link to="/transport/loading/waiting" className="panel-link">
                <ListItemButton
                  sx={{ pr: 4 }}
                  className={selectedMenu('/transport/loading/waiting')}
                >
                  <ListItemText>
                    <div className="sub-menu"> در پارکینگ جهت بارگیری </div>
                  </ListItemText>
                </ListItemButton>
              </Link>
              <Link to="/transport/loading/polomp" className="panel-link">
                <ListItemButton
                  sx={{ pr: 4 }}
                  className={selectedMenu('/transport/loading/polomp')}
                >
                  <ListItemText>
                    <div className="sub-menu"> در انتظار پلمپ </div>
                  </ListItemText>
                </ListItemButton>
              </Link>
              {/* <Link to="/transport/waiting" className="panel-link">
                <ListItemButton
                  sx={{ pr: 4 }}
                  className={selectedMenu('/transport/waiting')}
                >
                  <ListItemText>
                    <div className="sub-menu"> پشت درب شرکت </div>
                  </ListItemText>
                </ListItemButton>
              </Link> */}

              {/* <Link to="/transport/onTheWay" className="panel-link">
                <ListItemButton
                  sx={{ pr: 4 }}
                  className={selectedMenu('/transport/onTheWay')}
                >
                  <ListItemText>
                    <div className="sub-menu"> در مسیر پارکنیگ </div>
                  </ListItemText>
                </ListItemButton>
              </Link> */}
              {/* <Link to="/transport/inParking" className="panel-link">
                <ListItemButton
                  sx={{ pr: 4 }}
                  className={selectedMenu('/transport/inParking')}
                >
                  <ListItemText>
                    <div className="sub-menu"> رسیده به پارکینگ </div>
                  </ListItemText>
                </ListItemButton>
              </Link> */}
              {/* <Link to="/transport" className="panel-link">
                <ListItemButton
                  sx={{ pr: 4 }}
                  className={selectedMenu('/transport')}
                >
                  <ListItemText>
                    <div className="sub-menu"> گزارش کلی وضعیت </div>
                  </ListItemText>
                </ListItemButton>
              </Link> */}
            </List>
          </Collapse>
        ) : (
          ''
        )}
        <ListItemButton onClick={handleClickFilter}>
          {openMenu ? openFilter ? <ExpandLessIcon /> : <ExpandMoreIcon /> : ''}
          {openMenu ? <ListItemText primary=" بارگیری / تخلیه " /> : ''}

          <ListItemIcon style={styleList}>
            <FactoryIcon className="ms-auto" />
          </ListItemIcon>
        </ListItemButton>
        {openMenu ? (
          <Collapse in={openFilter} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              <Link to="/weighbridge/loading" className="panel-link">
                <ListItemButton
                  sx={{ pr: 4 }}
                  className={selectedMenu('/weighbridge/loading')}
                >
                  <ListItemText>
                    <div className="sub-menu"> بارگیری </div>
                  </ListItemText>
                </ListItemButton>
              </Link>
              <Link to="/weighbridge/discharge" className="panel-link">
                <ListItemButton
                  sx={{ pr: 4 }}
                  className={selectedMenu('/weighbridge/discharge')}
                >
                  <ListItemText>
                    <div className="sub-menu"> تخلیه </div>
                  </ListItemText>
                </ListItemButton>
              </Link>
            </List>
          </Collapse>
        ) : (
          ''
        )}
        {/* <ListItemButton onClick={handleClickLoadings}>
          {openMenu ? (
            openLoadings ? (
              <ExpandLessIcon />
            ) : (
              <ExpandMoreIcon />
            )
          ) : (
            ''
          )}
          {openMenu ? <ListItemText primary="آمار بارگیری روزانه " /> : ''}

          <ListItemIcon style={styleList}>
            <TableChartIcon className="ms-auto" />
          </ListItemIcon>
        </ListItemButton> */}
        {/* {openMenu ? (
          <Collapse in={openLoadings} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              {loadings.map((load, index) => {
                return (
                  <Link
                    key={index}
                    to={`/weighbridge/filterloadings/${
                      load.geoDestination.length > 1
                        ? load.geoDestination
                        : 'undefined'
                    }`}
                    className="panel-link"
                  >
                    <ListItemButton
                      sx={{ pr: 4 }}
                      className={selectedMenu(
                        `/weighbridge/${
                          load.geoDestination.length > 1
                            ? load.geoDestination
                            : 'undefined'
                        }`,
                      )}
                    >
                      <ListItemText>
                        <div className="sub-menu">
                          <Badge
                            color="secondary"
                            badgeContent={FromInt(load.count)}
                            max={70000}
                          >
                            {load.geoDestination.length > 1
                              ? load.geoDestination
                              : 'تعیین نشده'}
                          </Badge>
                        </div>
                      </ListItemText>
                    </ListItemButton>
                  </Link>
                );
              })}
            </List>
          </Collapse>
        ) : (
          ''
        )} */}
        <ListItemButton className="text-danger" onClick={logOut}>
          {openMenu ? <ListItemText primary="خروج" /> : ''}

          <ListItemIcon style={styleList}>
            <ExitToApp className="ms-auto text-danger" />
          </ListItemIcon>
        </ListItemButton>
      </List>
    </>
  );
}

export default TopNav;
